import React from 'react';

const BuyNow = () => {
    return (
        <div className='md:h-screen '>

            <p className='my-10 md:ml-64 ml-10' >
                <img className='w-3/4 h-2/4 text-center ' src="https://t3.ftcdn.net/jpg/03/53/83/92/360_F_353839266_8yqhN0548cGxrl4VOxngsiJzDgrDHxjG.jpg" alt="" />
            </p>

        </div>
    );
};

export default BuyNow;